import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { UserQuitRequestBody, UserQuitResponse } from "./types";

export class UserQuitAPI extends BaseAPI<
  UserQuitRequestBody,
  UserQuitResponse
> {
  protected route = ApiRoutes.auth.quit;
  protected method = RequestMethod.PUT;
}
